import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CONTENT_COLLAPSE_STATE } from 'site-modules/editorial/constants/best';
import { TruncatedTextLite } from 'site-modules/shared/components/truncated-text-lite/truncated-text-lite';
import { TitleLink } from './title-link';
import { CardButtons } from './card-buttons';

const INDICATOR_CLASS_NAME = 'small text-primary-darker ms-0_25';
const MAX_TEXT_LENGTH = {
  MOBILE: 140,
  DESKTOP: 260,
};

export function CardContent({
  ariaId = null,
  titleLink,
  subtitle,
  content,
  primaryLink,
  secondaryLink,
  contentCollapseState,
  number = null,
  isTopDataPoints = true,
  isMobile = false,
}) {
  const isFullCollapse = isMobile && contentCollapseState !== CONTENT_COLLAPSE_STATE.PARTIAL;

  return (
    <div className="card-content h-100 pos-r pt-md-1 pe-md-1">
      {!isMobile && (
        <Fragment>
          <TitleLink
            titleLink={titleLink}
            subtitle={subtitle}
            headingClassName={classnames({ 'pe-1_5': number })}
            ariaId={ariaId}
          />
          {number && <div className="number heading-4 bg-gray-lighter px-0_5 py-0_25">{number}</div>}
        </Fragment>
      )}
      <div className="mt-md-1">
        <TruncatedTextLite
          text={content}
          className={classnames('card-text text-gray-darker', {
            'top-border': isMobile && isTopDataPoints,
            'collapse-no-border': isFullCollapse,
          })}
          btnClassName="size-16 text-gray-darker mt-0_25"
          indicatorOpenClass={classnames(INDICATOR_CLASS_NAME, 'icon-arrow-down4')}
          indicatorCloseClass={classnames(INDICATOR_CLASS_NAME, 'icon-arrow-up4')}
          maxTextLength={isMobile ? MAX_TEXT_LENGTH.MOBILE : MAX_TEXT_LENGTH.DESKTOP}
          isFullCollapse={isFullCollapse}
          isOpenOnLoad={contentCollapseState === CONTENT_COLLAPSE_STATE.NONE}
          expandTrackingId="best_vehicle_read_more"
          collapseTrackingId="best_vehicle_read_more"
          ariaIds={ariaId}
        />
      </div>

      {!isMobile && <CardButtons primaryLink={primaryLink} secondaryLink={secondaryLink} ariaId={ariaId} />}
    </div>
  );
}

CardContent.propTypes = {
  ariaId: PropTypes.string,
  titleLink: PropTypes.shape({
    url: PropTypes.string,
    blank: PropTypes.bool,
    nofollow: PropTypes.bool,
    title: PropTypes.string,
  }).isRequired,
  primaryLink: PropTypes.shape({
    url: PropTypes.string,
    blank: PropTypes.bool,
    nofollow: PropTypes.bool,
    title: PropTypes.string,
  }).isRequired,
  secondaryLink: PropTypes.shape({
    url: PropTypes.string,
    blank: PropTypes.bool,
    nofollow: PropTypes.bool,
    title: PropTypes.string,
  }).isRequired,
  subtitle: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  contentCollapseState: PropTypes.oneOf(Object.values(CONTENT_COLLAPSE_STATE)).isRequired,
  number: PropTypes.number,
  isTopDataPoints: PropTypes.bool,
  isMobile: PropTypes.bool,
};
